import { render, staticRenderFns } from "./LegendFooter.vue?vue&type=template&id=950d52c0&scoped=true&"
import script from "./LegendFooter.vue?vue&type=script&lang=js&"
export * from "./LegendFooter.vue?vue&type=script&lang=js&"
import style0 from "./LegendFooter.vue?vue&type=style&index=0&id=950d52c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "950d52c0",
  null
  
)

export default component.exports